<template>
    <div class="hc mt-4" style="min-height: 18vh; border-radius: 15px; border: 1px solid #E3E3E3; position: relative;">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <div class="d-flex align-items-center row pl-3 pr-3">
        <div class="d-flex col-3 justify-content-start align-items-center mt-2 mb-1" style="border-right: 2px solid #E6E6E6;">
          <em class="diente_outline" style="width: 1.5em;"></em>
          <p class="mt-3 ml-3" style="font-weight: 500;">Múltiple selección</p>
        </div>

        <div class="col-7">
          <b-form-select id="padecimiento" name="padecimiento" placeholder="Agregar padecimiento"
                        v-model="auxiliar"
                        :disabled="disable"
                        :options="padecimientos"
                        class="ml-3 statePadecimiento select"
                        value-field="idPadecimiento"
                        text-field="descripcion">
                    </b-form-select>
        </div>
      </div>
  
      <div v-if="multiplesDientes.length > 0" class="mt-3 pl-5 pr-5">
        <b-row class="mt-2 ml-2">
          Dientes agregados:
        </b-row>
        <div class="row">
          <div v-for="(diente,i) in multiplesDientes" :key="diente + i" class="bordeCards col-2 ml-3 mt-2" style="padding-left: 1%; padding-right: 0px;">
            <div class="d-flex justify-content-between align-items-center" style="height: 35px;font-size: .9em; color: #90D3DD;">
              <em class="diente_outline" style="width: 1.2em;"></em>
              <div style="color: #50A6B3;">
                <p class="mt-3 text-center" style="color: #31A3B4;" v-if="diente.diente.length<= 2"> OD {{ diente.diente }}</p>
                <p class="mt-3 text-center" style="color: #31A3B4;" v-else>{{ diente.diente }}</p>
              </div>
              <b-button v-if="!disable" size="sm" v-b-tooltip.hover title="Eliminar Diente"
                style="color: rgb(0, 115, 255) !important;" variant="link"
                @click="eliminarDiente(i)">
                  <font-awesome-icon icon="times-circle"/>
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-4 mb-3">
        <div class="d-flex justify-content-between" style="width: 30%;">
          <b-button pill class="custom-primary" :disabled="multiplesDientes.length < 1 || padecimiento == null"
            @click="guardar()">Guardar
          </b-button>
          <b-button pill variant="outline-secondary"
            @click="cancelar()">Cancelar
          </b-button>
        </div>
        </div>
    </div>
  </template>
  
  <script>
  import {CatalogosService} from "@/apiServices/catalogos/CatalogosService";
  import {PtiPresuntivoService} from "@/apiServices/ptiPresuntivo/PtiPresuntivoService";
  
  export default {
    name: "MultiplesODS",
    components: {},
    props: {
      statePadecimientoAdicional: null,
      disable: {
        type: Boolean,
        default: false
      },
      detalle: {
        type: Boolean,
        default: false
      },
      descentralizado: Boolean,
      ptiCdxForzado:  {
        type: Boolean,
        default: false
      },
      diente: {
        required: true,
        default: {
          diente: null,
          padecimiento: {
            idPadecimiento: null,
            descripcion: null,
            etapa: null,
          },
        }
      },
      idDenticion: {
        type: Number,
        required: true,
        default: null
      },
      idTagMotivoCita: {
        type: Number,
        required: true,
        default: null
      },
      idClinica: {
        type: Number,
        required: true,
        default: null
      },
      idPaciente: Number,
      idEmpleado: Number,
      index: null,
      multiplesDientes: Array
    },
    data: () => {
      return {
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,

        auxiliar: null,
        seccEtapa:false,
        padecimientos: [],
        catalogosServicios: new CatalogosService(),
        ptiPrsuntivoServicio: new PtiPresuntivoService(),
        listaDientes: [],
        etapas: [],
        idEtapa: null,
        padecimiento: null,
        multiplesOds: []
      }
    },
    created() {
      this.debug = this.$localStorageService.getDebug();

      this.idEtapa = this.$route.params.idEtapa
      this.obtenerPadecimientos()
      this.obtenerEtapas()
  
      this.seccEtapa = this.descentralizado || this.ptiCdxForzado;
    },
    watch: {
        auxiliar(newVal) {
            let objetoBuscado = this.padecimientos.find(objeto => objeto.idPadecimiento == newVal);
            this.padecimiento = objetoBuscado;
        },
    },
    methods: {
      obtenerEtapas() {
        this.$http.get(
            this.$api + "padecimientotagetapa/obteneretapas"
        )
            .then((response) => {
              this.etapas = response.data.data
            })
      },
      obtenerPadecimientos() {
        const params = {
          denticion: this.idDenticion,
          idTagMotivoCita: this.idTagMotivoCita
        }
        this.catalogosServicios.obetenerPadecimientosPorDienteDescentralizados(params).then(
            response => {
              this.padecimientos = [
                        { idPadecimiento: null, descripcion: "Selecciona un padecimiento" },
                        ...response.data
                    ];
            }
        )
      },
  
      rutaClinica() {
        this.$emit("rutaClinica")
      },
      eliminarDiente(i) {
        this.$emit('eliminarDienteMultiple', this.multiplesDientes[i])
        this.multiplesDientes.splice(i,1)
      },

      guardar(){
        this.$swal.fire({
          title: "Multiples OD´s",
          text: "Se agregarán "+ this.multiplesDientes.length +" nuevos OD´s ¿Desea continuar?",
          focusConfirm: false,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          customClass: {
              confirmButton: "rounded-pill btn-warning text-small",
              cancelButton: "rounded-pill btn-danger text-small",
          },
        })
        .then((result) => {
            if (result.isConfirmed) {
              this.$emit("multiplesODSeleccionados", {dientes: this.multiplesDientes, padecimiento: this.padecimiento});
            }
        });
      },

      cancelar(){
        this.$emit('cancelarMultiple')
      },
    }
  }
  </script>
  
  <style scoped>
   .hc p {
    color: #7A7A7A; 
  }

  .select{
    border: none !important;
    border-bottom: 2px solid #90D3DD !important;
    box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
  }

  .select:focus{
    border: none !important;
    box-shadow: 0px 1px 4px 0px #90D3DD;
  }

  .bordeCards{
    border: 1px solid #D6E7F3;
    border-radius: 1rem;
  }

  .custom-primary {
    background-color: #3F9BD3 !important; 
    border-color: #3F9BD3 !important; 
  }

  .custom-primary:hover {
    background-color: #FFF !important; 
    border-color: #3F9BD3 !important; 
    color: #3F9BD3 !important; 
  }


.bottom-div {
  position: absolute;
  bottom: 0;

}

  .esconder[aria-expanded="true"] {
    display: none;
  }
  
  .esconder[aria-expanded="false"] {
    display: initial;
  }
  
  .mostrar[aria-expanded="true"] {
    display: initial;
  }
  
  .mostrar[aria-expanded="false"] {
    display: none;
  }
  
  .descripcionDiente {
    margin-right: 1rem;
    border-right: solid 1px #c7c7c7
  }
  
  </style>